// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crop-image-wrapper {
  height: 400px;
  /* Adjust the height as needed */
  overflow: auto; }

.errMsg {
  color: red;
  font-size: 11px; }
`, "",{"version":3,"sources":["webpack://./src/layouts/profile/editMyProfile/editProfilr.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAA;EACA,cAAc,EAAA;;AAGhB;EACE,UAAU;EACV,eAAe,EAAA","sourcesContent":[".crop-image-wrapper {\n  height: 400px;\n  /* Adjust the height as needed */\n  overflow: auto;\n}\n\n.errMsg {\n  color: red;\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
